import { useMemo } from 'react';
import { first } from 'lodash';

import { useGetPracticeSettings } from 'store/settings/selectors';
import type { Currency } from 'types/entities/currency';

export function useGetDefaultAvailableCurrency(): Currency | undefined {
  const { availableCurrencies } = useGetPracticeSettings();

  return useMemo(() => {
    const firstCurrency = first(availableCurrencies);

    return firstCurrency
      ? {
          code: firstCurrency,
        }
      : undefined;
  }, [availableCurrencies]);
}
